import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import App from './App';
import './styles/index.css';

// Create a React Query client with default options
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
      // A change made elsewhere (a customer approving/rejecting via their own tracking-page tab,
      // another staff member editing the same ticket, or this same ticket updated from the queue
      // list) has no way to reach an already-open screen - there's no push notification for it
      // (SignalR infrastructure exists but isn't wired to these events). Refetching on window
      // focus is the cheap partial fix: switching back to a tab re-validates its data instead of
      // silently showing whatever was last fetched, without needing a full real-time build-out.
      refetchOnWindowFocus: true,
    },
    mutations: {
      retry: 0,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
        <Toaster
          position="top-center"
          reverseOrder={false}
          toastOptions={{
            duration: 4000,
            style: {
              fontFamily: "'Discovery FS', Rubik, Heebo, sans-serif",
              direction: 'rtl',
            },
          }}
        />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
